import { useContext } from 'react'
import { WrapperContext } from '../../../interfaces/contexts'
import { TableModal } from './tableModal'

export const ModalPicker = () => {
  const { initModal } = useContext(WrapperContext)

  if (!initModal?.state?.id) return <></>

  return (
    <>
      <TableModal
        isShow={initModal.state.id === 'table-modal' ? true : false}
      />
    </>
  )
}
